<template>
  <b-form-group
    label="Alt Başlık"
    label-for="sub_title"
  >
    <b-form-input
      id="sub_title"
      v-model="itemData.sub_title"
      placeholder="Alt Başlık"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'SubTitleText',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    itemData() {
      return this.$store.getters['modLeads/dataItem']
    },
  },
}
</script>
